import type { TileMetadata, TileStatusDto } from "../../../../types/bim-viewer.types";

// 4 LODs, evenly distributed across an 80x80x80 building bounding box.
// LOD 0 = single coarse mesh; LOD 3 = high detail per quadrant.
const tilesPerLod = [1, 4, 16, 64];

const buildTiles = (): TileMetadata[] => {
  const tiles: TileMetadata[] = [];
  let id = 1;
  tilesPerLod.forEach((count, lod) => {
    const gridSize = Math.ceil(Math.cbrt(count));
    const cell = 80 / gridSize;
    for (let i = 0; i < count; i++) {
      const gx = i % gridSize;
      const gy = Math.floor(i / gridSize) % gridSize;
      const gz = Math.floor(i / (gridSize * gridSize));
      tiles.push({
        tileId: id,
        modelId: 9001,
        lodLevel: lod,
        tilePath: `mock://tiles/9001/lod${lod}/tile-${i}.glb`,
        tileUrl: `mock://tiles/9001/lod${lod}/tile-${i}.glb`,
        boundingBox: {
          min: [gx * cell, gy * cell, gz * cell],
          max: [(gx + 1) * cell, (gy + 1) * cell, (gz + 1) * cell],
        },
        fileSize: 80_000 + lod * 240_000 + Math.floor(Math.random() * 50_000),
        status: "ready",
        elementCount: Math.floor(15240 / count),
      });
      id += 1;
    }
  });
  return tiles;
};

export const mockTiles: TileMetadata[] = buildTiles();

export const mockTileStatus: TileStatusDto = {
  modelId: 9001,
  status: "ready",
  totalTiles: mockTiles.length,
  readyTiles: mockTiles.length,
  failedTiles: 0,
  startedAt: "2026-05-21T16:45:00Z",
  completedAt: "2026-05-21T16:51:42Z",
};
